import { state } from './state';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
import { Module } from 'vuex';
import { AuthStoreType } from '@/types/store/auth-store.type';
import { StoreType } from '@/types/store/store.type';

const namespaced: boolean = true;
export const auth: Module<AuthStoreType, StoreType> = {
  namespaced,
  state,
  actions,
  mutations,
  getters
};
